import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: linear-gradient(to bottom, #fafbfc 0%, #ffffff 100%);
`;

export const Header = styled.div`
   padding:  15px 0px;

  h2 {
    margin: 0 0 8px 0;
    font-size: 1.75rem;
    font-weight: 600;
    color: #ffffff;
    letter-spacing: -0.02em;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;

export const HeaderSubtitle = styled.p`
  margin: 0;
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 400;
`;

export const Content = styled.div`
  padding: 24px 0px;
  flex: 1;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f3f4;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c7cd;
    border-radius: 4px;
    
    &:hover {
      background: #a8adb3;
    }
  }
`;

export const TableContainer = styled.div`
  grid-area: History;
  margin-top: 15px;
`;

